import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import workspaceReducer from "./slices/workspaceSlice";
import testReducer from "./slices/testSlice";
import projectReducer from "./slices/projectSlice";
import folderReducer from "./slices/folderSlice";
import suiteReducer from "./slices/suiteSlice";
import suiteExecutionReducer from "./slices/suiteExecutionSlice";
import dataSetReducer from "./slices/dataSetSlice";
import searchReducer from "./slices/searchSlice";

const store = configureStore({
	reducer: {
		auth: authReducer,
		workspace: workspaceReducer,
		test: testReducer,
		projects: projectReducer,
		folders: folderReducer,
		suites: suiteReducer,
		suiteExecutions: suiteExecutionReducer,
		datasets: dataSetReducer,
		search: searchReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export default store;
